require("./bootstrap");
sw = require("stopword");

(function ($) {
    var _keyword = " ";
    var _keyword2 = " ";
    var current = -1;
    var total = 0;
    var isActive = false;
    var idToolbar = "instantSearch-toolbar";
    var offset = $(".navbar-wrapper").height() + 60 || 0;
    var excludeHtmlNode = [
        // ".modal-dialog",
        // ".modal-body",
        // ".modal-body *",
        // ".collsable",
        // ".collsable *",
        ".footnotes",
        ".note",
        ".note *",
    ];
    var options = {
        element: "span",
        className: "highlight",
        exclude: excludeHtmlNode,
        // "accuracy" : {"value": "exactly"},
        // "separateWordSearch": false
    };
    var content = document.querySelector(".content");
    var articleList = document.querySelector(".retult-articles");
    // Filter out numbers from Italian stopwords so digits like '8', '1161', '10' are never removed
    var itStopwords = (sw.it || []).filter(function (w) {
        return !/^\d+$/.test(w);
    });

    function getItalianWordVariants(word) {
        if (!word) return [];
        var w = word.toLowerCase().trim();
        var variants = [w];
        if (w.length < 3 || /^\d+$/.test(w)) {
            return variants;
        }

        // Italian morphological rules for singular / plural
        if (w.endsWith("chi")) {
            variants.push(w.slice(0, -3) + "co");
        } else if (w.endsWith("co")) {
            variants.push(w.slice(0, -2) + "chi");
            variants.push(w.slice(0, -2) + "ci");
        }
        if (w.endsWith("ghi")) {
            variants.push(w.slice(0, -3) + "go");
        } else if (w.endsWith("go")) {
            variants.push(w.slice(0, -2) + "ghi");
        }
        if (w.endsWith("che")) {
            variants.push(w.slice(0, -3) + "ca");
        } else if (w.endsWith("ca")) {
            variants.push(w.slice(0, -2) + "che");
        }
        if (w.endsWith("ghe")) {
            variants.push(w.slice(0, -3) + "ga");
        } else if (w.endsWith("ga")) {
            variants.push(w.slice(0, -2) + "ghe");
        }
        if (w.endsWith("io")) {
            variants.push(w.slice(0, -2) + "i");
        }
        if (w.endsWith("o")) {
            variants.push(w.slice(0, -1) + "i");
        }
        if (w.endsWith("a")) {
            variants.push(w.slice(0, -1) + "e");
        }
        if (w.endsWith("e")) {
            variants.push(w.slice(0, -1) + "i");
            variants.push(w.slice(0, -1) + "a");
        }
        if (w.endsWith("i")) {
            variants.push(w.slice(0, -1) + "o");
            variants.push(w.slice(0, -1) + "e");
            variants.push(w.slice(0, -1) + "a");
        }

        return variants.filter(function (val, idx, self) {
            return self.indexOf(val) === idx;
        });
    }

    function prepareKeywords(rawText, exact) {
        if (!rawText || !rawText.trim()) return [];
        if (exact) {
            return [rawText.trim()];
        }

        var tokens = rawText.trim().split(/\s+/);
        var filtered = tokens.filter(function (token) {
            var lower = token.toLowerCase();
            if (/\d/.test(lower)) return true;
            return itStopwords.indexOf(lower) === -1;
        });

        var baseTokens = filtered.length > 0 ? filtered : tokens;
        var allWords = [];
        baseTokens.forEach(function (token) {
            var variants = getItalianWordVariants(token);
            variants.forEach(function (v) {
                if (allWords.indexOf(v) === -1) {
                    allWords.push(v);
                }
            });
        });

        return allWords;
    }

    var fire = function (keyword, exact) {
        var searchKeywords = prepareKeywords(keyword, exact);
        var oldKeywords = prepareKeywords(_keyword2, $('input[name="q-exactmatch"]').val() == 1);

        current = -1;
        total = 0;
        var mark = new Mark(content, options);

        mark.unmark({});

        if (oldKeywords.length > 0) {
            mark.mark(oldKeywords, {
                className: "old-search",
                exclude: excludeHtmlNode,
                separateWordSearch:
                    $('input[name="q-exactmatch"]').val() == 1
                        ? false
                        : true,
            });
        }

        if (searchKeywords.length > 0) {
            mark.mark(searchKeywords, {
                separateWordSearch: exact ? false : true,
                exclude: excludeHtmlNode,
                done: function (result) {
                    if (result > 0) {
                        total = result;
                        showToolbar();
                    } else {
                        current = -1;
                        total = 0;
                        hideToolbar();
                    }
                },
            });
        } else {
            hideToolbar();
        }

        _keyword = keyword;
    };

    var showToolbar = function () {
        isActive = true;
        var c = current + 1;
        if (!$("#" + idToolbar).length > 0) {
            template = `
                <div id="${idToolbar}" class="shadow-lg">
                    <button class="instantSearch-prev instantSearch-btn"><i class="fas fa-backward"></i></button>
                    <div class="instantSearch-counter">
                        ${c} &bsol; ${total}
                    </div>
                    <button class="instantSearch-next instantSearch-btn"><i class="fas fa-forward"></i></button>
                </div>
            `;
            $("body").append(template);
        }
        updateCounter();
    };

    var hideToolbar = function () {
        isActive = false;
        $("#" + idToolbar).fadeOut();
        $("#" + idToolbar).remove();
    };

    var updateCounter = function () {
        var c = current + 1;
        $(".instantSearch-counter").html(`${c} &bsol; ${total}`);
    };

    var selectWord = function () {
        let isInModal = false;
        $("mark").removeClass("mark-select");
        currentMark = $($("mark").not(".old-search"))[current];
        $(currentMark).addClass("mark-select");

        if($(currentMark).parents(".modal").length > 0) {
            isInModal = true;
        }

        if ($(currentMark).offset()) {
            window.scrollTo({ top: $(currentMark).offset().top - offset });
        }

        if(isInModal) {
            if(!$(currentMark).parents(".modal").hasClass("show")) {
                $(currentMark).parents(".modal").modal("show");
            }
        }

        updateCounter();
    };

    var init_search_query = function () {
        // var keyword2 = sw.removeStopwords(_keyword2.split(' '), sw.it).join(' ');
        // var mark = new Mark(content, options);
        // mark.mark(keyword2, {
        //     "element": "span",
        //     "className": "old-search",
        // });
    };

    $("document").ready(function () {
        _keyword = $('[name="search"]').val() || " ";
        _keyword2 = $('[name="q"]').val() || " ";
        var _exactMatch = $("#instantaExactMatch").prop("checked");

        // if(articleList) {
        //    var keyword2 = sw.removeStopwords(_keyword2.split(' '), sw.it).join(' ');
        //    var mark = new Mark(articleList, options);
        //     mark.mark(keyword2, {
        //         "className": "old-search",
        //     });
        // }

        if (_keyword) {
            fire(_keyword, _exactMatch);
            ++current;
            // selectWord();
        }

        $('[name="search"]').on("keyup", function (e) {
            e.preventDefault();
            var keyword = $(this).val();
            _exactMatch = $("#instantaExactMatch").prop("checked");
            fire(keyword, _exactMatch);
            if (e.keyCode === 13) {
                ++current;
                selectWord();
            }
        });

        $("#instantaExactMatch").on("change", function (e) {
            e.preventDefault();
            var keyword = $('[name="search"]').val();
            _exactMatch = $(this).prop("checked");
            fire(keyword, _exactMatch);
        });

        $("body").on("click", ".instantSearch-btn", function (e) {
            e.preventDefault();
            if ($(this).hasClass("instantSearch-next")) {
                ++current;
                if (current >= total) {
                    current = total - 1;
                }
            } else {
                --current;
                if (current < 0) {
                    current = 0;
                }
            }
            selectWord();
        });

        $("body").on("keyup", function (e) {
            if ($(e.target).is("input, textarea, select, [contenteditable]")) {
                return;
            }
            if (isActive) {
                if (e.keyCode == 39 || e.keyCode == 13) {
                    current++;
                    if (current >= total) {
                        current = total - 1;
                    }
                } else if (e.keyCode == 37) {
                    --current;
                    if (current < 0) {
                        current = 0;
                    }
                }
                selectWord();
            }
        });
    });
})(jQuery);
